<template>
  <div class="charge-fee-container">
    <TableList
      ref="TableList"
      v-loading="listLoading"
      :dataList="list"
      :columnAllData="columnAllData"
      :showSelection="false"
      :canRefresh="false"
      :canChangeColumn="false"
      :isShowPagination="false"
      :canCommand="false"
      :showSummary="false"
      :maxHight="224"
    >
      <template v-slot:typeName="scope">
        <el-tag
          :type="scope.row.amount < 0 ? 'warning' : 'success'"
          size="small"
          effect="light"
        >
          {{ scope.row.amount < 0 ? '客户退款' : '客户收款' }}
        </el-tag>
      </template>
      <template v-slot:amount="scope">
        <span :style="{ color: scope.row.amount < 0 ? '#e6a23c' : 'inherit', fontWeight: scope.row.amount < 0 ? '600' : 'normal' }">
          {{ scope.row.amount < 0 ? `-${$currency(Math.abs(scope.row.amount))}` : $currency(scope.row.amount) }}
        </span>
      </template>
    </TableList>
    <div class="charge-fee-summary mt-10" v-if="list.length > 0">
      <span class="mr-20">实收累计：<strong style="color: #67c23a;">{{ $currency(summary.totalReceived) }}</strong></span>
      <span class="mr-20">退款累计：<strong style="color: #e6a23c;">{{ $currency(summary.totalRefund) }}</strong></span>
      <span>净收总额：<strong style="color: var(--blue);">{{ $currency(summary.netFee) }}</strong></span>
    </div>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref, watch, computed } from 'vue'
import { getPageList } from '@/apis/Form'

import { CostModel } from '@/model/Index'

import TableList from '@/components/common/TableList.vue'
// import { TableName, permissionName } from '@/utils/enum'
import { TableField } from './FieldTable'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'ChargeFee',
  components: {
    TableList
  },
  props: {
    id: { type: Number, required: true, default: 0 },
    api: { type: String, required: false, default: 'business' }
  },

  emits: ['charge-fee'],
  setup(props, context) {
    const { t } = useI18n()
    const TableList = ref(null)

    const dataMap = reactive({
      columnAllData: TableField,
      activeId: 0,
      list: [],
      listLoading: false,

      summary: computed(() => {
        let totalReceived = 0
        let totalRefund = 0
        dataMap.list.forEach((item: any) => {
          if (item.amount < 0) {
            totalRefund += Math.abs(item.amount)
          } else {
            totalReceived += Number(item.amount) || 0
          }
        })
        return {
          totalReceived,
          totalRefund,
          netFee: totalReceived - totalRefund
        }
      }),

      async getList() {
        if (!props.id) {
          dataMap.list = []
          return
        }
        dataMap.listLoading = true
        let result = []
        try {
          if (props.api === 'business') {
            result = await getPageList(`business/${props.id}/actions/receivedRecords`)
          } else if (props.api === 'outsourceFee') {
            result = await getPageList(`outsourceFee/${props.id}/actions/details`)
          } else if (props.api === 'purchasFee') {
            result = await getPageList(`purchase/details/${props.id}/actions/payment`)
          } else {
            result = await getPageList(`order/${props.id}/actions/receivedRecords`)
          }
          dataMap.list = result || []
          dataMap.listLoading = false
          let chargeFee = 0
          dataMap.list.forEach((item: any) => {
            chargeFee += item.amount
          })
          context.emit('charge-fee', chargeFee)
        } catch (error) {
          console.log(error, 'error')
          dataMap.listLoading = false
        }
      }
    })

    watch(() => props.id, () => {
      dataMap.getList()
    })

    onMounted(async() => {
      dataMap.getList()
    })
    return { TableList, t, ...toRefs(dataMap) }
  }
})
</script>
<style lang="scss" scoped>
.charge-fee-summary {
  display: flex;
  justify-content: flex-end;
  padding: 8px 16px;
  background-color: var(--surface-subtle, #f8fafc);
  border-radius: var(--r-xs, 6px);
  font-size: 13px;
  color: var(--ink-muted);
}
</style>
